<template>
    <v-text-field v-model="filterValue" @input="handleInputChange"
    clearable @click:clear="handleClear" :label="st(config.label)"></v-text-field>
</template>
 
 <script> 

import BaseModule from '../../../common/BaseModule.js'

 export default {
   name: 'TextFilter',
   props: ['config','context'],
   mixins: [BaseModule],
   components: { 
   },
   data() {
       return {
           debounceTimeout: null,
           filterValue: null,
           lastEvent: null
       }
   },
    mounted() {
    },
    watch: {
        context: function() { 
			if (!this.context.filters || this.context.filters.length === 0) {
				this.filterValue = null;
                this.lastEvent = this.filterValue;
				return;
			}
			var filter = this.context.filters.find(f => this.matchesCurrentFilter(f));
			if (filter) {
				this.filterValue = this.normalizeFilterValue(filter.value);
                this.lastEvent = this.filterValue;
			} else {
				this.filterValue = null;
                this.lastEvent = this.filterValue;
			}
        },
     },
     destroyed() { 
        clearTimeout(this.debounceTimeout);
    },
    methods: {
        matchesCurrentFilter(filter) {
            if (!filter || filter.type !== this.config.type) {
                return false;
            }

            return JSON.stringify(filter.fields || []) === JSON.stringify(this.config.fields || []);
        },
        getValue() {
            return this.filterValue;
        },
        normalizeFilterValue(value) {
            if (value === null || value === undefined) {
                return null;
            }
            const normalized = String(value).trim();
            return normalized === '' ? null : normalized;
        },
        emitFilterValue() {
            const normalizedValue = this.normalizeFilterValue(this.filterValue);
            if (normalizedValue == this.lastEvent) {
                return;
            }
            this.lastEvent = normalizedValue;
            this.$emit('change', normalizedValue);
        },
        handleClear() {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = null;
            }
            this.filterValue = null;
            this.emitFilterValue();
        },
        handleInputChange() {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
            }
            const me = this;
            this.debounceTimeout = setTimeout(() => {
                me.emitFilterValue();
            }, 400);
        }
    }
 };
 </script>
  
